const content: { [key: string]: string } = {
  toastMessage: "Business Changed Successfully",
  dropdownLabel: "Business Selector",
};

export default content;
